import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import styles from './PreguntasFrecuentes.module.css';
import { useScrollAnimation } from '../../../ganchos/usarAnimacionScroll';

const EJEMPLOS = [
  { q: '¿Ofrecen servicio técnico a nivel nacional?', a: 'Sí, cubrimos toda Guatemala con nuestro equipo técnico especializado, garantizando respuesta rápida para lavanderías industriales y comercios.' },
  { q: '¿Qué marcas de equipos distribuyen?', a: 'Somos distribuidores autorizados de marcas líderes a nivel mundial como Speed Queen, Unimac, BATTISTELLA y más, asegurando calidad premium.' },
  { q: '¿Cuentan con inspección por boroscopía?', a: 'Así es. Utilizamos tecnología de boroscopía avanzada para inspeccionar el estado interno de tuberías industriales sin necesidad de romper estructuras.' },
  { q: '¿Venden repuestos originales?', a: 'Contamos con un amplio stock de repuestos originales para todas las marcas que representamos, asegurando la vida útil de su inversión.' }
];

export const FAQ = () => {
  const [ref, visible] = useScrollAnimation({ threshold: 0.08 });
  const [index, setIndex] = useState(0);
  const [fading, setFading] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setFading(true);
      setTimeout(() => {
        setIndex((prev) => (prev + 1) % EJEMPLOS.length);
        setFading(false);
      }, 400); // 400ms for fade out
    }, 5000); // Change every 5 seconds
    return () => clearInterval(interval);
  }, []);

  return (
    <section id="faq" ref={ref} className={`${styles.seccion} ${visible ? styles.visible : ''}`}>
      <div className="container">
        <div className={styles.grid}>
          {/* Lado Izquierdo: Títulos y CTA */}
          <div className={styles.encabezado}>
            <h2 className={styles.titulo}><span className={styles.acento}>Preguntas</span> Frecuentes</h2>
            <div className={`${styles.lineaTitulo} ${visible ? styles.lineaVisible : ''}`} />
            <p className={styles.sub}>Respuestas a las dudas más comunes sobre nuestros servicios, productos y metodología de trabajo.</p>
            <div className={`${styles.btnContainer} ${visible ? styles.btnVisible : ''}`}>
              <Link to="/preguntas-frecuentes" className={styles.faqBtn}>
                Ver todas las preguntas
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="18" height="18">
                  <path d="M5 12h14M12 5l7 7-7 7"/>
                </svg>
              </Link>
            </div>
          </div>

          {/* Lado Derecho: Ejemplo Dinámico */}
          <div className={`${styles.dinamicoContainer} ${visible ? styles.dinamicoVisible : ''}`}>
            <div className={styles.dinamicoBox}>
              <div className={`${styles.dinamicoContenido} ${fading ? styles.fading : ''}`}>
                <h3 className={styles.preguntaDin}>{EJEMPLOS[index].q}</h3>
                <p className={styles.respuestaDin}>{EJEMPLOS[index].a}</p>
              </div>
              
              {/* Indicadores de progreso (dots) */}
              <div className={styles.dots}>
                {EJEMPLOS.map((_, i) => (
                  <span key={i} className={`${styles.dot} ${i === index ? styles.dotActivo : ''}`} />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
export default FAQ;
